import type { Detection } from '../../ui/detection-overlay';
import type { FullFrameSizeReturn } from '../../ui/full-frame';

interface GetScaledDetectionsProps {
  detections: Detection;
  rescale: number;
  size: FullFrameSizeReturn;
}

export const getScaledDetections = ({
  detections,
  rescale = 1,
  size,
}: GetScaledDetectionsProps): Detection => {
  const hasSize = size?.containerSize && size?.imageSize;
  const canRenderDetections = Array.isArray(detections.coordinates) && detections.coordinates.length > 0;

  if (!hasSize || !canRenderDetections) return detections;

  const scaleX = (size.containerSize.width / size.imageSize.width) * rescale;
  const scaleY = (size.containerSize.height / size.imageSize.height) * rescale;

  if (detections.type === 'bbox') {
    return {
      ...detections,
      coordinates: detections.coordinates.map((coordinate) => {
        if (Array.isArray(coordinate)) {
          const [x1, y1, x2, y2] = coordinate;

          return {
            x: x1 * scaleX,
            y: y1 * scaleY,
            width: (x2 - x1) * scaleX,
            height: (y2 - y1) * scaleY,
          };
        }

        return {
          x: coordinate.x * scaleX,
          y: coordinate.y * scaleY,
          width: coordinate.width * scaleX,
          height: coordinate.height * scaleY,
        };
      }),
    };
  }

  if (detections.type === 'point') {
    return {
      ...detections,
      coordinates: detections.coordinates.map(([x, y]) => [
        x * scaleX,
        y * scaleY,
      ]),
    };
  }

  return detections;
};
